module.exports = __webpack_public_path__ + "img/hipline.c684aa87.png";